<template>
  <div id="inputCpf">
    <el-date-picker
      :id="id"
      type="date"
      v-model="model"
      @change="select"
      ref="pickerDateInput"
      format="dd/MM/yyyy"
      :readonly="readonly"
      :editable="editable"
      :disabled="disabled"
      value-format="yyyy-MM-dd"
      class="fix-padding-right"
      :placeholder="placeholder"
    >
    </el-date-picker>
  </div>
</template>
<script type="text/javascript">
import moment from 'moment'
export default {
  name: 'input-data',
  props: {
    id: { type: String },
    icon: { type: String },
    value: { type: String },
    placeholder: { type: String },
    readonly: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    editable: { type: Boolean, default: true }
  },
  data() {
    return {
      model: ''
    }
  },
  mounted() {
    this.model = this.value
    this.addNewFunctionParser()
  },
  methods: {
    select(value) {
      this.$emit('input', value)
    },
    addNewFunctionParser() {
      this.$nextTick(() => {
        const elPicker = this.$refs.pickerDateInput
        const originalParseFunction = elPicker.parseString
        const newParseFunction = this.expandNumbersToDate
        elPicker.parseString = function(value) {
          value = newParseFunction(value)
          return originalParseFunction(value)
        }
      })
    },
    expandNumbersToDate(value) {
      const currentMonth = moment().format('MM')
      const currentYear = moment().format('YYYY')
      value = value.replace(/^[^\d]*(\d{2})[^\d]*$/, `$1/${currentMonth}/${currentYear}`)
      value = value.replace(/^[^\d]*(\d{2})(\d{2})[^\d]*$/, `$1/$2/${currentYear}`)
      value = value.replace(/^[^\d]*(\d{2})\/?(\d{2})\/?(\d{4})[^\d]*$/, '$1/$2/$3')
      return value
    }
  },
  watch: {
    value(vl) {
      this.model = vl
    }
  }
}
</script>
<style lang="css">
.fix-padding-right > .el-input__inner {
  padding-right: unset !important;
}

.el-input {
  width: 100% !important;
}
</style>
